export enum AuthenticationMethodType {
  Email = 'email',
  Google = 'google',
}
